import React, { useState, useEffect } from 'react';
import axios from 'axios';

function SalesPage({ apiUrl, auth }) {
  const [rentals, setRentals] = useState([]);
  const [dateFilter, setDateFilter] = useState('');

  useEffect(() => {
    loadRentals();
  }, [dateFilter]);

  const loadRentals = async () => {
    try {
      const params = dateFilter ? { date: dateFilter } : {};
      const res = await axios.get(`${apiUrl}/rentals`, { params });
      setRentals(res.data);
    } catch (err) {
      console.error('Erreur:', err);
    }
  };

  const totalRevenue = rentals.reduce((sum, r) => sum + r.total, 0);

  return (
    <div>
      <div className="page-header">
        <h1>🧾 Ventes</h1>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <input
            type="date"
            value={dateFilter}
            onChange={e => setDateFilter(e.target.value)}
            style={{ padding: '8px 12px', border: '1px solid var(--border)', borderRadius: '8px', fontSize: '14px' }}
          />
          {dateFilter && (
            <button className="btn btn-outline btn-sm" onClick={() => setDateFilter('')}>
              Tout afficher
            </button>
          )}
        </div>
      </div>

      <div className="stats-grid" style={{ marginBottom: '20px' }}>
        <div className="stat-card revenue">
          <div className="stat-label">Total {dateFilter ? `du ${new Date(dateFilter).toLocaleDateString('fr-FR')}` : 'général'}</div>
          <div className="stat-value">{totalRevenue.toFixed(0)} DA</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Nombre de locations</div>
          <div className="stat-value">{rentals.length}</div>
        </div>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Ticket</th>
              <th>Articles</th>
              <th>Total</th>
              <th>Employé</th>
              <th>Date & Heure</th>
            </tr>
          </thead>
          <tbody>
            {rentals.length === 0 ? (
              <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', color: 'var(--text-secondary)' }}>Aucune vente trouvée</td></tr>
            ) : (
              rentals.map(rental => (
                <tr key={rental.id}>
                  <td><span className="badge badge-info">#{rental.ticket_number}</span></td>
                  <td>{rental.items.map(i => `${i.name} x${i.qty}`).join(', ')}</td>
                  <td style={{ fontWeight: '700', color: 'var(--success)' }}>{rental.total.toFixed(0)} DA</td>
                  <td>{rental.employee_name || '-'}</td>
                  <td style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>
                    {rental.created_at ? new Date(rental.created_at).toLocaleDateString('fr-FR', {
                      day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
                    }) : '-'}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SalesPage;
